<template>
  <div>
    <van-popup
        v-model="showPop"
        closeable
        close-icon="close"
        round
        v-if="popInfo && popInfo.props"
    >
      <div class="wrapper" :style="{width: popWidth+'px'}">

        <van-row @click="onPopClick">
          <van-col span="24">
            <div class="popImage">
              <AnimeScale :config="popInfo.props">
                <Wp_image :url="popInfo.props.img"/>
              </AnimeScale>
            </div>
          </van-col>
          <van-col span="24">
            <div class="popContent">
              <div v-html="linkContent"/>
            </div>
          </van-col>
        </van-row>

      </div>
    </van-popup>
    <van-popup
        v-model="showActivityInfo"
        closeable
        round
        position="bottom"
        :style="{ height: '90%' }"
    >
      <JdActivityInfoCard :act-data="currentActivityInfo"></JdActivityInfoCard>
    </van-popup>
  </div>
</template>
<script>
import Wp_image from '../custom/Wp_image'
import common from '../../js/common'
import JdActivityInfoCard from '../card/JdActivityInfoCard'
import AnimeScale from '../anime/AnimeScale'

export default {
  name: 'Wp_home_pop_model',
  components: { AnimeScale, JdActivityInfoCard, Wp_image },
  props: {
    params: { type: Object },
    list: { type: Array },
    imgGray: { type: Boolean, default: false }
  },
  data () {
    return {
      screenWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,     // 屏幕宽
      screeHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,    // 屏幕高
      popWidth: '300px',
      showPop: false,
      showActivityInfo: false,
      url: '',
      popList: [],
      popInfo: {},
      linkContent: '',
      currentActivityInfo: {},
    }
  },
  mounted () {
    this.popWidth = this.screenWidth - 80
    this.initStaticPop(popInfo => {
      this.showPopInfo()
    })
    if (!this.popInfo || !this.popInfo.id) {
      this.initPopData(popInfo => {
        this.showPopInfo()
      })
    }
  },
  methods: {
    showPopInfo () {
      if (this.popInfo) {
        this.makePopContent(this.popInfo)
        setTimeout(() => {
          let _autoPlay = 1000 * 60
          if (this.params.auto_play) {
            _autoPlay = this.params.auto_play
          }
          let current_time = Date.parse(new Date())
          let old_time = this.$store.state.show_pop_old_time
          if (current_time - old_time > _autoPlay) {
            this.$store.commit('setShowPopOldTime', current_time)
            this.showPop = true
          } else {
            this.showPop = false
          }

        }, 2000)
      }
    },
    initPopData (fn) {
      if (this.params) {
        if (this.params.url) {
          this.url = this.params.url
          this.loadUrl(this.url, fn)
        }
      }
    },
    initStaticPop (fn) {
      if (this.list && this.list.length > 0) {
        for (let i in this.list) {
          let _staticPop = this.list[i]
          this.popList.push(_staticPop)
        }
        if (this.popList && this.popList.length > 0) {
          let _pop = this.popList[this.getRandomNum()]
          this.popInfo = _pop
          if (fn) {
            fn(this.popInfo)
          }
        }
      }
    },
    loadUrl (url, fn) {
      if (url) {
        url = this.$union_utils.handleUbb(url)
        this.$union_utils.getUrl(url, res => {
          if (res.code === 200) {
            let _list = res.data
            for (let i in _list) {
              let _data = _list[i]
              let _popInfo = this.getPropInfo(_data)
              if (_popInfo) {
                this.popList.push(_popInfo)
              }
            }
            let _pop = this.popList[this.getRandomNum()]
            if (_pop) {
              this.popInfo = _pop
              if (fn) {
                fn(this.popInfo)
              }
            }
          }
        })
      }
    },
    getRandomNum () {
      return Math.floor(Math.random() * this.popList.length)
    },
    getPropInfo (data) {
      if (data) {
        let _img = this.$union_utils.getActivityImage(data.imgList, '350*350')
        if (_img) {
          let _propInfo = {
            component: 'pop_cell',
            props: {
              id: 'C_1620890584077',
              img: _img,
              url: data.urlM,
              urlM: data.urlM,
              title: data.title,
              url_type: -1,
              wx_hide: false,
              actData: data,
            }
          }
          return _propInfo
        }
      }
    },
    getStaticPopInfo () {

    },
    makePopContent (popInfo) {
      if (popInfo && popInfo.props) {
        let props = popInfo.props
        if (props && props.text) {
          this.linkContent = props.text.replace(new RegExp('\\n', 'g'), '<br/>') + '<br/>'
        }
        if (props && props.actData) {
          let actData = props.actData
          this.linkContent = actData.title + '<br/>'
          if (actData.advantage) {
            this.linkContent = this.linkContent + actData.advantage + '<br/>'
            let _act_time = this.getActTime(actData)
            if (_act_time) {
              this.linkContent = this.linkContent + '活动时间:' + _act_time + '<br/>'
            }
          }
        }
      }
    },
    getActTime (actData) {
      if (actData) {
        let endTime = new Date(actData.endTime)
        let startTime = new Date(actData.startTime)
        return this.$common.dateFmt('yyyy.MM.dd', startTime) + '-' + this.$common.dateFmt('yyyy.MM.dd', endTime)
      }
    },
    onPopClick () {
      let item = this.popInfo.props
      console.log(item)
      if (item.actData) {
        if (this.$common.getPid()) {
          this.currentActivityInfo = item.actData
          if (common.isClient()) {
            this.$union_utils.getActivityUnionLink(this.currentActivityInfo, shortUrl => {
              window.location.href = shortUrl
            })
          } else {
            this.showActivityInfo = true
          }
        } else {
          this.$toast.fail({
            message: '此内容注册用户才可查看'
          })
        }
      } else {
        this.$clickHomeModelTo(item)
      }
    }
  }
}
</script>
<style>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}

.popImage {
  padding: 20px;
}

.popContent {
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #FFC116;
}

.van-popup--center.van-popup--round {
  border-radius: 16px;
  background-color: transparent;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
</style>